import { TreeGrid, Resize as TreeGridResize } from '@syncfusion/ej2-treegrid';
/**
 * Column resize action related code goes here
 */
export class Resize {
    constructor(gantt) {
        this.parent = gantt;
        TreeGrid.Inject(TreeGridResize);
        this.parent.treeGrid.allowResizing = this.parent.allowResizing;
        this.bindEvents();
    }
    /**
     * Get module name
     *
     * @returns {void} .
     */
    getModuleName() {
        return 'resize';
    }
    /**
     * To bind resize events.
     *
     * @returns {void} .
     * @private
     */
    bindEvents() {
        this.parent.treeGrid.resizeStart = (args) => {
            if (this.parent.undoRedoModule && this.parent['isUndoRedoItemPresent']('ColumnResize')) {
                this.parent.undoRedoModule['createUndoCollection']();
                const details = {};
                details['action'] = 'ColumnResize';
                details['resizedColumn'] = Object.assign({}, args.column);
                this.parent.undoRedoModule['getUndoCollection'][this.parent.undoRedoModule['getUndoCollection'].length - 1] = details;
            }
            this.parent.trigger('resizeStart', args);
        };
        this.parent.treeGrid.resizing = (args) => {
            this.parent.trigger('resizing', args);
        };
        this.parent.treeGrid.resizeStop = (args) => {
            this.parent.trigger('resizeStop', args);
        };
    }
    /**
     * To destroy the column-resizer.
     *
     * @returns {void} .
     * @private
     */
    destroy() {
        // Destroy Method
    }
}
